/* istanbul ignore file */
export const selectTitle = (state) => state.office.title;
export const selectEmergencies = (state) => state.office.emergency;
